import { ISunCalc, ISunCalcResult, DayPhase } from "./ISunCalc.js";
import { DateUtil } from "../utils/DateUtil.js";

/**
 * https://github.com/Fabiz/MeeusJs
 */
export class SunCalcMeeusJs implements ISunCalc {
    public calc(date: Date, lat: number, lng: number): ISunCalcResult {
        var jdo = new A.JulianDay(date);
        var coord = A.EclCoord.fromWgs84(lat, lng, 0);
        var sunPos = A.Solar.topocentricPosition(jdo, coord, true);
        var moonPos = A.Moon.topocentricPosition(jdo, coord, true);
        var times = A.Solar.times(jdo, coord);

        var d = new Date(date);
        // d.setUTCMinutes(d.getUTCMinutes() + 10);
        var sunPosDelta = A.Solar.topocentricPosition(new A.JulianDay(d), coord, true);

        // console.log(sunPos.eq);

        var result: ISunCalcResult = {
            sun: {
                altitude: sunPos.hz.alt,
                azimuth: sunPos.hz.az
            },
            moon: {
                altitude: moonPos.hz.alt,
                azimuth: moonPos.hz.az
            },
            phase: "night",
            ratio: 0,
            solstice: false
        }
        

        var sunAngle = result.sun.altitude * 180 / Math.PI;

        // if (!times) {
        //     //summer/winter solistice 
        //     result.phase = sunAngle > 0 ? "day" : "night";
        //     result.solstice = true;
        //     return result;
        // }

        var maxAngle = 6;
        // var riseDate = new Date(DateUtil.toString(date) + " " + A.Coord.secondsToHMSStr(times.rise));
        // var setDate = new Date(DateUtil.toString(date) + " " + A.Coord.secondsToHMSStr(times.set));
        // var isRising = Math.abs(date.getTime() - riseDate.getTime()) < Math.abs(date.getTime() - setDate.getTime());

        var isRising = sunPosDelta.hz.alt > sunPos.hz.alt;

        if (Math.abs(sunAngle) < maxAngle && isRising) {
            result.phase = "sunrise";
            result.ratio = e5.Calc.ratio(sunAngle, -maxAngle, maxAngle);
        } else if (sunAngle > maxAngle) {
            result.phase = "day";
            result.ratio = 0;
        } else if (Math.abs(sunAngle) < maxAngle && !isRising) {
            result.phase = "sunset";
            result.ratio = e5.Calc.ratio(sunAngle, maxAngle, -maxAngle);
        } else {
            result.phase = "night";
            result.ratio = 0;
        }

        return result;
    }
}